export enum Variants {
  pill = 'pill',
  secondary = 'secondary',
  outline = 'outline',
  text = 'text',
  white = 'white',
  gray = 'gray',
  border = 'border',
  black = 'black',
  transparent = 'transparent',
}

export enum ComponentVariants {
  button = 'button',
  a = 'a',
  router = 'router',
}

export enum Size {
  normal = 'normal',
  small = 'small',
}
